// ✅ For owner API calls — uses "token"
export const authHeader = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

// ✅ For admin API calls — uses "adminToken"
export const adminAuthHeader = () => {
  const token = localStorage.getItem("adminToken");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

// ✅ Handle API responses globally — redirect on 401
export const handleApiResponse = (response) => {
  if (response.status === 401) {
    // Token expired or invalid — clear tokens and redirect to login
    localStorage.removeItem("token");
    localStorage.removeItem("adminToken");
    localStorage.removeItem("ownerRole");
    localStorage.removeItem("adminRole");
    window.location.href = "/";
    return false; // Don't proceed with normal response handling
  }
  return true; // Continue with normal response handling
};
